import { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";


import { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa";
import calender from "../../../../assets/css/calender.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import EditPipeline from "./EditPipeline";

const EditDealModal = ({ show, handleClose }) => {
    const [showPipeline, setShowPipeline] = useState(false);
 const [followupDate, setFollowupDate] = useState(null);
      const [dueDate, setDueDate] = useState(new Date());
  const [closingDate, setClosingDate] = useState(new Date());
  

  const dueRef = useRef();
  const closingRef = useRef();
    const [input, setInput] = useState("");
  const [tags, setTags] = useState(["Vaughan Lewis"]);

  // Add tag on Enter
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && input.trim() !== "") {
      e.preventDefault();

      // Avoid duplicates
      if (!tags.includes(input.trim())) {
        setTags([...tags, input.trim()]);
      }

      setInput("");
    }
  };

  // Remove tag
  const removeTag = (index) => {
    const updated = tags.filter((_, i) => i !== index);
    setTags(updated);
  };

// proj
 const [projectInput, setProjectInput] = useState("");
  const [projectTags, setProjectTags] = useState([
    "Office Management",
    "Clinic Management",
  ]);

  // Add tag
  const handleProjectKeyDown = (e) => {
    if (e.key === "Enter" && projectInput.trim() !== "") {
      e.preventDefault();

      if (!projectTags.includes(projectInput.trim())) {
        setProjectTags([...projectTags, projectInput.trim()]);
      }

      setProjectInput("");
    }
  };

  // Remove tag
  const removeProjectTag = (index) => {
    setProjectTags(projectTags.filter((_, i) => i !== index));
  };

  // assign
  const [assigneeInput, setAssigneeInput] = useState("");
  const [assigneeTags, setAssigneeTags] = useState([
    "Vaughan Lewis",
  ]);

  // Add tag
  const handleAssigneeKeyDown = (e) => {
    if (e.key === "Enter" && assigneeInput.trim() !== "") {
      e.preventDefault();

      if (!assigneeTags.includes(assigneeInput.trim())) {
        setAssigneeTags([
          ...assigneeTags,
          assigneeInput.trim(),
        ]);
      }

      setAssigneeInput("");
    }
  };

  // Remove tag
  const removeAssigneeTag = (index) => {
    setAssigneeTags(
      assigneeTags.filter((_, i) => i !== index)
    );
  };

  // tag
    const [tagInput, setTagInput] = useState("");
  const [tagList, setTagList] = useState(["Collab"]);

  // Add tag
  const handleTagKeyDown = (e) => {
    if (e.key === "Enter" && tagInput.trim() !== "") {
      e.preventDefault();

      if (!tagList.includes(tagInput.trim())) {
        setTagList([...tagList, tagInput.trim()]);
      }

      setTagInput("");
    }
  };

  // Remove tag
  // const removeTag = (index) => {
  //   setTagList(tagList.filter((_, i) => i !== index));
  // };


  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="deal-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Deals</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <Row>
            <Col md={6}>
              <Form.Label>Deal Name *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
                  <option>vamsi</option>
                    <option>kumar</option>
              </Form.Select>
            </Col>

            <Col md={6}>
              <Form.Label>Status *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
                  <option>open</option>
                    <option>win</option>
              </Form.Select>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <div className="d-flex justify-content-between">
                <Form.Label>Pipeline *</Form.Label>
<span onClick={() => setShowPipeline(true)} className="add-new">
  + Add New
</span>
              </div>
              <Form.Select className="custom-select">
                <option>Select</option>
                 <option>Sales</option>
                  <option>Marketing</option>
                  <option>Calls</option>

              </Form.Select>
            </Col>

            <Col md={6}>
              <Form.Label>Currency *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
                <option>USD</option>
                <option>Euro</option>

              </Form.Select>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Label>Deal Value *</Form.Label>
              <Form.Control />
            </Col>

            <Col md={6}>
              <Form.Label>Period Value *</Form.Label>
              <Form.Control />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Label>Period *</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
              </Form.Select>
            </Col>

        <Col md={6}>
      <Form.Label>Contact *</Form.Label>

      <div className="tags-box">
        {tags.map((tag, index) => (
          <span key={index} className="tag">
            {tag}
            <button onClick={() => removeTag(index)}>✕</button>
          </span>
        ))}

        <input
          type="text"
          placeholder="Add new"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
    </Col>
          </Row>

 <Form.Group className="mt-3">
      <Form.Label>
        Project <span className="text-danger">*</span>
      </Form.Label>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "6px",
          border: "1px solid #ddd",
          padding: "8px",
          borderRadius: "8px",
          minHeight: "45px",
        }}
      >
        {projectTags.map((tag, index) => (
          <span
            key={index}
            style={{
              background: "#f1f5f9",
              padding: "4px 8px",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "13px",
            }}
          >
            {tag}
            <button
              onClick={() => removeProjectTag(index)}
              style={{
                border: "none",
                background: "none",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
          </span>
        ))}

        <input
          type="text"
          placeholder="Add new"
          value={projectInput}
          onChange={(e) => setProjectInput(e.target.value)}
          onKeyDown={handleProjectKeyDown}
          style={{
            border: "none",
            outline: "none",
            flex: 1,
            minWidth: "120px",
          }}
        />
      </div>
    </Form.Group>

<Row className="mt-1">
      {/* Due Date */}
      <Col xs={12} className="w-100%" lg={6}>
        <Form.Group className="w-100%" >
          <Form.Label>
            Due Date <span className="text-danger">*</span>
          </Form.Label>

          <div className="date-input-wrapper">
            <DatePicker
              selected={dueDate}
              onChange={(date) => setDueDate(date)}
              dateFormat="dd-MM-yyyy"
              placeholderText="dd/mm/yyyy"
              className="form-control custom-input w-100%"
              calendarClassName="custom-calendar"
              popperPlacement="bottom-start"
            />
            <FaRegCalendarAlt className="calendar-icon-deal" />
          </div>
        </Form.Group>
      </Col>

      {/* Expected Closing Date */}
      <Col xs={12} className="w-50%" lg={6}>
        <Form.Group>
          <Form.Label>
            Expected Closing Date <span className="text-danger">*</span>
          </Form.Label>

          <div className="date-input-wrapper">
            <DatePicker
              selected={closingDate}
              onChange={(date) => setClosingDate(date)}
              dateFormat="dd-MM-yyyy"
              placeholderText="dd/mm/yyyy"
              className="form-control custom-input"
              calendarClassName="custom-calendar"
              popperPlacement="bottom-start"
            />
            <FaRegCalendarAlt className="calendar-icon-deal" />
          </div>
        </Form.Group>
      </Col>
    </Row>

   
<Form.Group className="mt-3">
      <Form.Label>
        Assignee <span className="text-danger">*</span>
      </Form.Label>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "6px",
          border: "1px solid #ddd",
          padding: "8px",
          borderRadius: "8px",
          minHeight: "45px",
        }}
      >
        {assigneeTags.map((tag, index) => (
          <span
            key={index}
            style={{
              background: "#f1f5f9",
              padding: "4px 8px",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "13px",
            }}
          >
            {tag}
            <button
              onClick={() => removeAssigneeTag(index)}
              style={{
                border: "none",
                background: "none",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
          </span>
        ))}

        <input
          type="text"
          placeholder="Add new"
          value={assigneeInput}
          onChange={(e) =>
            setAssigneeInput(e.target.value)
          }
          onKeyDown={handleAssigneeKeyDown}
          style={{
            border: "none",
            outline: "none",
            flex: 1,
            minWidth: "120px",
          }}
        />
      </div>
    </Form.Group>

          <Row className="mt-3">
          
      <Col md={6}>
        <Form.Label>
          Tags <span className="text-danger">*</span>
        </Form.Label>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "6px",
            border: "1px solid #ddd",
            padding: "8px",
            borderRadius: "8px",
            minHeight: "45px",
          }}
        >
          {tagList.map((tag, index) => (
            <span
              key={index}
              style={{
                background: "#f1f5f9",
                padding: "4px 8px",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "13px",
              }}
            >
              {tag}
              <button
                onClick={() => removeTag(index)}
                style={{
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
            </span>
          ))}

          <input
            type="text"
            placeholder="Add new"
            value={tagInput}
            onChange={(e) => setTagInput(e.target.value)}
            onKeyDown={handleTagKeyDown}
            style={{
              border: "none",
              outline: "none",
              flex: 1,
              minWidth: "120px",
            }}
          />
        </div>
      </Col>
  

        <Col md={6}>
      <Form.Label>
        Followup Date <span className="text-danger">*</span>
      </Form.Label>

      <div
        className="date-box-follow"
        onClick={(e) =>
          e.currentTarget.querySelector("input").focus()
        }
      >
        <DatePicker
          selected={followupDate}
          onChange={(date) => setFollowupDate(date)}
          dateFormat="dd-MM-yyyy"
          placeholderText="dd/mm/yyyy"
          className="form-control custom-input"
          calendarClassName="custom-calendar"
          popperPlacement="bottom-start"
        />

        <FiCalendar style={{position:"absolute" , left:"",top:"13px"}} />
      </div>
    </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Label>Source *</Form.Label>
              <Form.Select className="custom-select">
                <option>Phone Calls</option>
                <option>Social Media</option>
                <option>Refferal Sites</option>
                <option>Websites Analytics</option>
                {/* <option>Select</option> */}

              </Form.Select>
            </Col>

            <Col md={6}>
              <Form.Label>Priority *</Form.Label>
              <Form.Select className="custom-select">
                <option>High</option>
                <option>Low</option>
                <option>Medium</option>


              </Form.Select>
            </Col>
          </Row>

          <Form.Group className="mt-3">
            <Form.Label>Description *</Form.Label>
            <Form.Control as="textarea" rows={3} />
          </Form.Group>

          {/* FOOTER */}
          <div className="footer-actions">
            <Button variant="light" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="btn-orange">Save</Button>
          </div>

        </Modal.Body>
       <EditPipeline

  show={showPipeline}
  handleClose={() => setShowPipeline(false)}
/>
      </Modal>

      {/* STYLES */}
      <style>{`
        .deal-modal .modal-content {
          border-radius: 10px;
        }

        .btn-orange {
          background:#ff6b2c;
          border:none;
          color:white;
        }

        .custom-select:focus {
          border-color:#ff6b2c;
          box-shadow:0 0 0 0.2rem rgba(255,107,44,0.2);
        }

        option:checked {
          background:#ff6b2c;
          color:white;
        }

        .date-box-follow{
          position:relative;
        }

        .date-box-follow svg {
          position:absolute;
          right:180px;
          top:2px;
          // left:"30px"
          // top: 50% !important; 
        }

        .tags-box {
          display:flex;
          flex-wrap:wrap;
          gap:6px;
          border:1px solid #ddd;
          padding:6px;
          border-radius:6px;
        }

        .tags-box span {
          background:#e5e7eb;
          padding:4px 8px;
          border-radius:6px;
          font-size:12px;
        }

        .tags-box input {
          border:none;
          outline:none;
          flex:1;
        }

        /* Calendar Icon */
.calendar-icon-deal {
  position: absolute;
 right: 170px;
  top: 50%; 
  transform: translateY(-50%);
  color: #6c757d;
  cursor: pointer;
}

/* Calendar Popup */
.custom-calendar {
  border-radius: 12px;
  border: none;
  box-shadow: 0px 4px 20px rgba(0,0,0,0.1);
  // padding: 10px;
}
        .add-new {
          color:#ff6b2c;
          font-size:13px;
          cursor:pointer;
        }

        .footer-actions {
          display:flex;
          justify-content:flex-end;
          gap:10px;
          margin-top:20px;
        }

        @media(max-width:768px){
          .footer-actions {
            flex-direction:column;
          }
        }
      `}</style>
    </>
  );
};

export default EditDealModal;